var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33335 11.0827H12.6667C12.8435 11.0827 13.0131 11.1441 13.1381 11.2535C13.2631 11.3629 13.3334 11.5113 13.3334 11.666C13.3334 11.8207 13.2631 11.9691 13.1381 12.0785C13.0131 12.1879 12.8435 12.2493 12.6667 12.2493H3.33335C3.15654 12.2493 2.98697 12.1879 2.86195 12.0785C2.73693 11.9691 2.66669 11.8207 2.66669 11.666C2.66669 11.5113 2.73693 11.3629 2.86195 11.2535C2.98697 11.1441 3.15654 11.0827 3.33335 11.0827ZM8.66669 7.68477L10.8287 5.7936L11.7714 6.61843L8.00002 9.91835L4.22869 6.61843L5.17135 5.7936L7.33335 7.68477V1.16602H8.66669V7.68477Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.248cf5bad16e457605ea5c5d2d9f3a2f.svg";
export { ForwardRef as ReactComponent };